import CloseOutlineSVG from './icon_close_outline.svg';
import withIconProps from './withIconProps';

export default withIconProps(CloseOutlineSVG);
